module.exports = __webpack_public_path__ + "img/p4.879e5ca4.png";